import React from "react";

/** Landing route after demo session redirect; replace copy or link as needed. */
export default function Plan() {
  return (
    <div style={{ padding: "2rem", maxWidth: 640, margin: "0 auto" }}>
      <h1>Plan</h1>
      <p>Choose a plan to continue.</p>
    </div>
  );
}
